var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unreadCount > 0)?_c('div',{staticClass:"global-nav__item-count a-notification-count is-only-mentor"},[_vm._v("\n  "+_vm._s(_vm.unreadCount)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }